import { withInstall } from '@pc-fx-framework/utils/with-install'
import VPieChart from './src/index.vue'

export const FxVPieChart = withInstall(VPieChart)
export default FxVPieChart

export * from './src/types'
